import { useNavigate } from 'react-router-dom';
import { useDemoMode } from '../contexts/DemoModeContext';

// Botão "ver com dados de exemplo" — só existe em `npm run dev`
// (import.meta.env.DEV é eliminado numa build de produção, então isto
// nunca aparece no site publicado). Usado nas duas telas de login, pra
// dar acesso às áreas com dados fictícios antes de existir backend real.
export function DemoModeLink({ to }: { to: string }) {
  const demoMode = useDemoMode();
  const navigate = useNavigate();

  if (!import.meta.env.DEV) {
    return null;
  }

  return (
    <button
      type="button"
      className="mt-3 w-full text-center text-xs text-[rgb(var(--text-muted))] hover:underline"
      onClick={() => {
        demoMode.enable();
        navigate(to);
      }}
    >
      Ver com dados de exemplo (modo de desenvolvimento)
    </button>
  );
}
